//App.js
import { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './App.css';
import VillageDetails from './VillageDetails'; 
import MessageDetails from './MessageDetails'; 
import WindowDetails from './WindowDetails'; 
import JobsDetails from './JobsDetails'; 
// import VillageMunch from './VillageMunch'; 

const WindowPanel = () => <div className="panel">एक खिडकी योजना</div>;
const EventsPanel = () => <div className="panel">समारंभ / उत्सव / जाहिर कार्यक्रम</div>;
const ProgramsPanel = () => <div className="panel">राबविलेले शासकीय उपक्रम</div>;
const JobsPanel = () => <div className="panel">शिक्षण, रोजगार संधी व तयारी (शासकीय / प्रायव्हेट)</div>;
// const VillageMunchPanel = () => <div className="panel">गांव मंच: व्यवसाय, जाहिरात आणि शुभेच्छांचे व्यासपीठ</div>;

const ChatPanel = () => (
  <div className="panel">
    नाविन्यपूर्ण गाव उपक्रम
    <p style={{ fontSize: 'smaller' }}>
      ग्रामपंचायत- सदस्य, अधिकारी व ग्रामस्थ यांच्या स्वखर्चाने/स्वयं-श्रमाने गाव विकासाचे नाविन्यपूर्ण उपक्रम
    </p>
  </div>
);
const SchemesPanel = () => <div className="panel">विविध शासकीय योजना </div>;
const AboutPanel = () => <div className="panel">आपली ग्राम पंचायत</div>;

const TabButton = ({ icon, label, active, onClick }) => (
  <button className={`tab-button ${active ? 'active' : ''}`} onClick={onClick}>
    <span className="material-icons">{icon}</span>
    <span className="tab-label">{label}</span>
  </button>
);

const panelVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

function App() {
  const gaonSrNo = 44;

  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');
  const [visitCount, setVisitCount] = useState(null);
  const [visitorCount, setVisitorCount] = useState(null);
  const hasUpdated = useRef(false);

  const handleShare = () => {
    const text = encodeURIComponent("आपल्या गावाची सारी माहिती आता एका ठिकाणी! www.mazagaon.co.in/akrale 🚀 आपल्या गावाची डिजिटल ओळख. सर्वांना शेअर करा.");
    window.open(`https://wa.me/?text=${text}`, "_blank");
  };

  useEffect(() => {
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  useEffect(() => {
    if (!hasUpdated.current) {
      hasUpdated.current = true;
      fetch(`https://mazagaon.co.in/api/visit_counter.php?gaonSrNo=${gaonSrNo}`)
        .then(res => res.json())
        .then(data => {
          if (data.visits !== undefined) setVisitCount(data.visits);
          if (data.visitors !== undefined) setVisitorCount(data.visitors);
        })
        .catch(err => console.error('Visit count error:', err));
    }
  }, [gaonSrNo]);

  const [highlightSuchana, setHighlightSuchana] = useState('');

  useEffect(() => {
    fetch(`https://mazagaon.co.in/api/get_highlight_suchana.php?gaonSrNo=${gaonSrNo}`)
      .then(res => res.json())
      .then(data => {
        if (data.Highlight_Suchana) {
          setHighlightSuchana(data.Highlight_Suchana);
        }
      })
      .catch(err => console.error('Highlight Suchana error:', err));
  }, [gaonSrNo]);

  const [activeTab, setActiveTab] = useState(() => localStorage.getItem('activeTab') || 'events');

  useEffect(() => {
    localStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  const renderPanel = () => {
    switch (activeTab) {
      case 'events': return <EventsPanel />;
      case 'programs': return <ProgramsPanel />;
      case 'newprograms': return <ChatPanel />;
      case 'schemes': return <SchemesPanel />;
      case 'about': return <AboutPanel />;
      case 'window': return <WindowPanel gaonSrNo={gaonSrNo} />;
      case 'jobs': return <JobsPanel />;
      // case 'VillageMunch': return <VillageMunchPanel />;


      default: return null;
    }
  };

  
  return (
    <div className={`app-container ${darkMode ? 'dark' : ''}`}>
      <div className="theme-toggle">
        <button onClick={() => setDarkMode(!darkMode)}>
          {darkMode ? '🌞 लाइट मोड' : '🌙 डार्क मोड'}
        </button>
      </div>

        <div className="visit-counter">👁️ Visits: {visitCount ?? '...'}</div>
        <div className="unique-visitor">👥Visitors: {visitorCount ?? '...'}</div>

      <div className='sharelink btn' onClick={handleShare}>
        <span className='sharesymbol'>⤴️</span>
        Share
      </div>

      <div className="main-content">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={panelVariants}
            transition={{ duration: 0.3 }}
          >
            {renderPanel()}
            {activeTab === 'about' && <VillageDetails gaonSrNo={gaonSrNo} />}
            {['events', 'programs', 'schemes', 'newprograms'].includes(activeTab) && (
              <MessageDetails gaonSrNo={gaonSrNo} curtab={activeTab} />
            )}
            {activeTab === 'window' && <WindowDetails gaonSrNo={gaonSrNo} />}
            {activeTab === 'jobs' && <JobsDetails gaonSrNo={gaonSrNo} />}

          </motion.div>
        </AnimatePresence>
      </div>

      {highlightSuchana && (
        <div className="scrolling-suchana">
          <div className="scrolling-text">📢 <b>ठळक सूचना:</b> {highlightSuchana}</div>
        </div>
      )}

      <div className="bottom-tabs">
        <TabButton icon="🏛️" label="ग्राम पं." active={activeTab === 'about'} onClick={() => setActiveTab('about')} />
        <TabButton icon="🖼️" label="एक खिडकी" active={activeTab === 'window'} onClick={() => setActiveTab('window')} />
        <TabButton icon="🎉" label="समारंभ" active={activeTab === 'events'} onClick={() => setActiveTab('events')} />
        <TabButton icon="📺" label="शासकीय उपक्रम" active={activeTab === 'programs'} onClick={() => setActiveTab('programs')} />
        <TabButton icon="🦸🏼" label="नाविन्यपूर्ण उपक्रम" active={activeTab === 'newprograms'} onClick={() => setActiveTab('newprograms')} />
        <TabButton icon="📆" label="योजना" active={activeTab === 'schemes'} onClick={() => setActiveTab('schemes')} />
        <TabButton icon="🪪" label="शिक्षण रोजगार" active={activeTab === 'jobs'} onClick={() => setActiveTab('jobs')} />

      </div>

      <div className="bottom-title">
        <h6 className="gtitle">अक्राळे</h6>
      </div>
    </div>
  );
}

export default App;
